export default __webpack_public_path__ + "static/media/Hero.78b08b99.jpeg";